module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mediaMain"
  }, [(_vm.mediaLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Scanned Documents")]), _vm._v(" "), _c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.mediaGridSpec.tableData,
      "columns": _vm.mediaGridSpec.columns,
      "options": _vm.mediaGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "download",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-cloud-download",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.mediaDownloadRow(props.row.scantoolMediaId, props.row.filename)
            }
          }
        })])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d82a290"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScantoolMedia.vue
// module id = 979
// module chunks = 1